import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { ButtonMui, MenuMui } from '../index'
import { MenuList, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material'
import { BiUser, BiExit, BiCaretDown, BiCaretUp } from 'react-icons/bi'

export default function NavUser(): React.ReactElement {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [isOpened, setIsOpened] = React.useState(false)
    const { logout, getUserInfo } = useContext(AuthContext) as AuthContextType
    const navigate = useNavigate()

    function handleClick(event: React.MouseEvent<HTMLButtonElement>): void {
        setAnchorEl(event.currentTarget)
    }

    function handleClose(): void {
        return setAnchorEl(null)
    }

    React.useEffect(() => {
        const navUser = document.querySelector('.nav-user')
        if (navUser !== null) {
            window.addEventListener('click', (e) => {
                if (!navUser?.contains(e.target as HTMLButtonElement)) setIsOpened(false)
            })
        }
    }, [])

    function toggleButton(): void {
        if (!isOpened) {
            setIsOpened(true)
        } else setIsOpened(false)
    }

    const user = getUserInfo()
    return (
        <div className="nav-user" onClick={() => toggleButton()}>
            <div className="drop-down">
                <ButtonMui
                    aria-haspopup="true"
                    aria-controls={isOpened ? 'basic-menu' : undefined}
                    aria-expanded={isOpened ? 'true' : undefined}
                    onClick={handleClick}
                    endIcon={isOpened ? <BiCaretUp /> : <BiCaretDown />}
                    variant="text"
                    size="large"
                >
                    {user?.name}
                </ButtonMui>

                <MenuMui open={isOpened} onClose={handleClose} anchorEl={anchorEl}>
                    <MenuList>
                        <Link to={'/profile'} className="drop-link">
                            <MenuItem>
                                <ListItemIcon>
                                    <BiUser />
                                </ListItemIcon>

                                <ListItemText>Perfil</ListItemText>
                            </MenuItem>
                        </Link>

                        <Divider />

                        <MenuItem
                            onClick={() => {
                                logout()
                                navigate('/login')
                            }}
                        >
                            <ListItemIcon>
                                <BiExit />
                            </ListItemIcon>

                            <ListItemText>Sair</ListItemText>
                        </MenuItem>
                    </MenuList>
                </MenuMui>
            </div>
        </div>
    )
}
